import { Base, withMountOnMediaQuery } from '@studiometa/js-toolkit';

/**
 * Mobile menu drawer.
 *
 * Monté uniquement sous le breakpoint `l`, là où le drawer est affiché. Au-delà,
 * le CSS le masque mais le scroll du body reste bloqué (`html.lock`) : on ferme
 * donc le drawer à la destruction du composant.
 */
export default class MobileMenu extends withMountOnMediaQuery(
  Base,
  'not all and (min-width: 64rem)',
) {
  /**
   * Config.
   */
  static config = {
    name: 'MobileMenu',
  };

  /**
   * Ferme le drawer quand on repasse en desktop.
   */
  destroyed() {
    const { activeClass = 'active' } = this.$el;

    if (this.$el.classList.contains(activeClass)) {
      this.$el.close();
    }
  }
}
